import axios from "axios";
import { FETCH_CUSTOMER_SUCCESS, FETCH_USERS_FAILURE, FETCH_USERS_REQUEST, FETCH_USERS_SUCCESS, FETCH_USERS_SUCCESS_2, FETCH_USER_FAILURE, FETCH_USER_REQUEST, FETCH_USER_SUCCESS } from "../../app/actions/actions";
import { ROUTES } from "../../config/routingUrl";
import { dureeDeVie, getAndCheckLocalStorage, setWithExpiration } from "../../utils/storage/localvalueFuction";
import { localStorageData, localStorageKeys } from "../../utils/storage/localvalue";
import { baseurl } from "../../utils/url/baseurl";
import { saveDataToFile } from "../DataLocal";
import { profileRoleType } from "../../utils/dataApi/dataFormApi";



// Create User
export const UserCreate = (
    data,
    navigate,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios
            .post(
                `${baseurl.url}/api/v1/users`,
                data,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success("Compte créer avec succès", { position: "bottom-right" });
                dispatch({ type: FETCH_USER_SUCCESS });
                dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: {} });
                navigate(`/${ROUTES.LOGIN}`)
                // window.location.href = `/${ROUTES.LOGIN}`;

            })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
                toast.error(`${error.response.data.message}`, { position: "bottom-right" })
            });
    };
}





export const UserUpdateById = (
    idUser,
    data,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios
            .put(
                `${baseurl.url}/api/v1/users/edit/${idUser}`,
                data,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success("Compte utilisateur mis ajour avec succès", { position: "bottom-right" });
                dispatch({ type: FETCH_USER_SUCCESS, payload: response.data.data });
                dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: {} });
                if (getAndCheckLocalStorage(localStorageKeys.userId) == idUser) {
                    setWithExpiration(localStorageKeys.userCoverPicture, response.data.data.profilePicture, dureeDeVie);
                    window.location.reload();
                } else {
                    dispatch(fetchUsersAll());
                }

                // window.location.href = `/${ROUTES.LOGIN}`;
            })
            .catch((error) => {
                toast.error("Mise à jour impossible", { position: "bottom-right" })
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
            });
    };
}















// Connexion User
export const UserConnexion = (usernameOremail, password, redirect, toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios
            .post(`${baseurl.url}/api/v1/users/auth/login`, {
                "email": usernameOremail,
                "password": password
            }, {
                headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                }
            })
            .then((response) => {
                //console.log(response.data.data)
                dispatch({ type: FETCH_USER_SUCCESS });

                window.localStorage.removeItem(localStorageKeys.adminId)
                window.localStorage.removeItem(localStorageKeys.userId)
                window.localStorage.removeItem(localStorageKeys.profileRole)
                window.localStorage.removeItem(localStorageKeys.userCoverPicture)
                window.localStorage.removeItem(localStorageKeys.adminCoverPicture)
                window.localStorage.removeItem(localStorageKeys.userName)
                window.localStorage.removeItem(localStorageKeys.userRole)
                // sub account
                window.localStorage.removeItem(localStorageKeys.ParentSubAcount)
                window.localStorage.removeItem(localStorageKeys.RoleSubAccountLabel)
                window.localStorage.removeItem(localStorageKeys.RoleSubAccountName)
                window.localStorage.removeItem(localStorageKeys.RoleSubAccountDescription)
                window.localStorage.removeItem(localStorageKeys.RoleSubAccountPermissions)
                //console.log(response.data.data);
                setWithExpiration(localStorageKeys.userId, response.data?.data?._id, dureeDeVie);
                setWithExpiration(localStorageKeys.userCoverPicture, response.data?.data?.profilePicture, dureeDeVie);
                setWithExpiration(localStorageKeys.userRole, response.data?.data?.role, dureeDeVie);
                setWithExpiration(localStorageKeys.userName, response.data?.data?.firstname + " " + response.data?.data?.lastname, dureeDeVie);
                setWithExpiration(localStorageKeys.profileRole, response.data?.role, dureeDeVie);
                setWithExpiration(localStorageKeys.ParentSubAcount, response.data?.data?.parents?._id, dureeDeVie);
                setWithExpiration(localStorageKeys.RoleSubAccountLabel, response.data?.data?.roleSubAccount?.label, dureeDeVie);
                setWithExpiration(localStorageKeys.RoleSubAccountName, response.data?.data?.roleSubAccount?.name, dureeDeVie);
                setWithExpiration(localStorageKeys.RoleSubAccountDescription, response.data?.data?.roleSubAccount?.description, dureeDeVie);
                setWithExpiration(localStorageKeys.RoleSubAccountType, response.data?.data?.roleSubAccount?.type, dureeDeVie);
                setWithExpiration(localStorageKeys.RoleSubAccountPermissions, response.data?.data?.roleSubAccount?.permissions, dureeDeVie);

                const parentId = response.data?.data?.parents?._id || "";                // ParentSubAcount: "ParentSubAcount",
                const roleSubAccount = response.data?.data?.roleSubAccount?.name || "";                // ParentSubAcount: "ParentSubAcount",
                //     RoleSubAccountLabel: "RoleLabel",
                //         RoleSubAccountName: "RoleName",
                //             RoleSubAccountDescription: "RoleDescription",
                //                 RoleSubAccountType: "RoleType",
                //                     RoleSubAccountPermissions: "RolePermissions",
                dispatch(fetchUsersAll());
                toast.success("Vous étes maintenant connecté", { position: "bottom-right" });

                setTimeout(() => {
                    if (parentId && roleSubAccount == "DRIVER") { redirect(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATIONS_REQUEST_LIST}`); }
                    else if (parentId && roleSubAccount == "HOME") { redirect(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATIONS_REQUEST_LIST}`); }
                    else if (parentId && roleSubAccount == "MAINTENANCE_TECHNICIAN") { redirect(`/${ROUTES.DASHBOARD}/${ROUTES.MAINTENANCE_LIST_PLATEFORME}`); }
                    else if (parentId && roleSubAccount == "DAMAGE_HANDLER") { redirect(`/${ROUTES.DASHBOARD}/${ROUTES.DAMAGES_LIST_PLATEFORM}`); }
                    else if (parentId && roleSubAccount == "INSURANCE_AGENT") { redirect(`/${ROUTES.DASHBOARD}/${ROUTES.INSURANCES_LIST_PLATEFORM}`); }
                    else if (parentId && roleSubAccount == "TREASURY_AGENT") { redirect(`/${ROUTES.DASHBOARD}/${ROUTES.REPORTING_LIST}`); }
                    else {
                        redirect(`/${ROUTES.DASHBOARD}`);
                    }
                    // window.location.href = `/${ROUTES.DASHBOARD}`;
                }, 1000);
            })
            .catch((error) => {
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
                toast.error(error.response.data.message || "Connexion Impossible", { position: "bottom-right" });
            });
    };
}







// All users of plateforme
export function fetchUsersAll(parents, startDate, endDate, firstname, lastname, email) {
    return async (dispatch) => {
        dispatch({ type: FETCH_USERS_REQUEST });
        const params = new URLSearchParams();
        // Préparer les paramètres de requête
        if (parents) params.append("parents", parents);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (firstname) params.append("firstname", firstname);
        if (lastname) params.append("lastname", lastname);
        if (email) params.append("email", email);

        await axios.get(`${baseurl.url}/api/v1/users/get_users?${params.toString()}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_USERS_SUCCESS, payload: response.data.data });
            dispatch({ type: FETCH_USERS_SUCCESS_2, payload: response.data.data });
            saveDataToFile(response.data.data, localStorageData.Users);
        })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_USERS_FAILURE, payload: error.message });
            });
    }
}











export function fetchUserById(idUser) {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios.get(`${baseurl.url}/api/v1/users/get_user/${idUser}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
            }
        }).then((response) => {
            //console.log(response.data.data);
            dispatch({ type: FETCH_USER_SUCCESS, payload: response.data.data });
            dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: {} });
        })
            .catch((error) => {
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message })
                //console.log(error);
            });
    }
}









export const UserUpdatePassword = (
    idUser,
    password,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USERS_REQUEST });

        await axios
            .post(`${baseurl.url}/api/v1/users/update-password/${idUser}`,
                {
                    password
                },
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success("Mot de passe Modifier avec succès", { position: "bottom-right" })
                dispatch({ type: FETCH_USER_SUCCESS });
                dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: {} });
            })
            .catch((error) => {
                toast.error("Mot de passe non mis à jour", { position: "bottom-right" })
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
            });
    };
}








// Reset password
export const UserResetPasswordForget = (
    email,
    password,
    setStep,
    showModal,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios
            .post(`${baseurl.url}/api/v1/users/reset-password`,
                {
                    email,
                    password
                },
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success(response?.data?.message || "Mot de passe mise  à jour avec succès", { position: "bottom-right" });
                dispatch({ type: FETCH_USER_SUCCESS });
                setStep(1);
                showModal(true);
                window.location.href = `/${ROUTES.LOGIN}`;
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Mot de passe non mis à jour", { position: "bottom-right" })
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
            });
    };
}




// Reset password
export const UserSendCodeverfiy = (
    email,
    phone,
    setSept,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios
            .post(`${baseurl.url}/api/v1/users/send-code-verify`,
                {
                    email,
                    phone
                },
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success(response?.data?.message || "Un code vous été envoyer sur votre email .", { position: "bottom-right" });
                setSept(2)
                dispatch({ type: FETCH_USER_SUCCESS });
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Le code n'a pas été entrez email valide . ", { position: "bottom-right" })
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
            });
    };
}




// Reset password
export const UserverfiyCode = (
    email, phone,
    passwordverifield,
    setStep,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios
            .post(`${baseurl.url}/api/v1/users/verfiy-code-reset`,
                {
                    _id: email || phone,
                    email,
                    phone,
                    passwordverifield,
                },
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success(response?.data?.message || "Le Code est accepter avec succès .", { position: "bottom-right" });
                dispatch({ type: FETCH_USER_SUCCESS });
                setStep(3)
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "Le code n'a pas été accepter entrer un code valide ", { position: "bottom-right" })
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
            });
    };
}







// Update statut user
export const UserUpdateStatut = (
    idUser,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        await axios
            .patch(`${baseurl.url}/api/v1/users/statut_user/${idUser}`,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                dispatch({ type: FETCH_USER_SUCCESS, payload: response.data.data });
                toast.success(response.data.message, { position: "bottom-right" });
                dispatch(fetchUsersAll());
            })
            .catch((error) => {
                toast.error(error?.response?.data?.message || "", { position: "bottom-right" })
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
            });
    };
}







export const UserSubCreate = (
    userId,
    roleId,
    data,
    toast) => {
    return async (dispatch) => {
        dispatch({ type: FETCH_USER_REQUEST });
        const params = new URLSearchParams();
        // Préparer les paramètres de requête
        if (userId) params.append("userId", userId);
        if (roleId) params.append("roleId", roleId);

        await axios
            .post(
                `${baseurl.url}/api/v1/users/subaccount?${params.toString()}`,
                data,
                {
                    headers:
                    {
                        'Content-Type': 'application/json',
                        'Authorization': `${baseurl.TypeToken} ${baseurl.token}`
                    }
                }
            )
            .then((response) => {
                toast.success(response?.data?.message || "Compte créer avec succès", { position: "bottom-right" });
                dispatch({ type: FETCH_USER_SUCCESS });
                dispatch(fetchUsersAll(userId))
                // dispatch({ type: FETCH_CUSTOMER_SUCCESS, payload: {} });
                // navigate(`/${ROUTES.LOGIN}`)
                // window.location.href = `/${ROUTES.LOGIN}`;

            })
            .catch((error) => {
                //console.log(error);
                dispatch({ type: FETCH_USER_FAILURE, payload: error.message });
                toast.error(error.response.data.message || "Sous non créer non créer", { position: "bottom-right" })
            });
    };
}
